<template>
 <div class="main">
   <!--<section class="page page-rsvp">-->
    <transition appear name="turnIn">
    <simplebar class="page page-rsvp" data-simplebar-auto-hide="true" v-bind:class="{ 'linkIsClicked' : linkClicked }">

    <h1>RSVP</h1>

    <p>Skicka ett mail med gästernas namn för <router-link to="/ceremoni">ceremonin</router-link> respektive <router-link to="/middag">middagen</router-link>.</p>
    <p>Ange vilken huvudrätt respektive person önskar vid middagen. Läs mer om vilka alternativ som bjuds under <router-link to="/middag">middagen</router-link>.</p>
    <p>Skicka mailet till <a href="mailto:david@redonion.se?subject=RSVP Bröllop">david@redonion</a> eller <a href="mailto:frida@redonion.se?subject=RSVP Bröllop">frida@redonion.se</a> eller ring oss senast <strong>den 31 januari 2022</strong>.</p>

    <hr class="page-hr">

    <!-- <nav class="navigation">
      <ul class="menu menu-rsvp">
        <li class="current"><router-link to="/rsvp">RSVP</router-link></li>
      </ul>

      <ul class="menu menu-left">
        <li><router-link to="/schema">Schema</router-link></li>
        <li><router-link to="/florens">Florens</router-link></li>
      </ul>

      <ul class="menu menu-center">
        <li class="current"><router-link to="/rsvp">RSVP</router-link></li>
      </ul>

      <ul class=" menu menu-right">
        <li><router-link to="/ceremoni">Ceremoni</router-link></li>
        <li><router-link to="/middag">Middag</router-link></li>
      </ul>
    </nav> -->

    <navigation @link-clicked="linkClickedFunc" v-bind:linkClickedC="linkClicked"></navigation>

    <!--</section>page-->
    </simplebar>
    </transition>
  </div><!--main-->
</template>

<script>

import simplebar from 'simplebar-vue';
// import 'simplebar/dist/simplebar.min.css'; //importerar denna som vanlig scss istället med copy paste för att få den inbakad i vanliga css filen

import Navigation from '../components/Nav.vue';

export default {
  name: 'rsvp',
  components: {
    simplebar,
    Navigation
  },
  data: function () {
    return {
      linkClicked: false
    };
  },

  methods: {
    linkClickedFunc (emittedvalue) {
      this.linkClicked = emittedvalue;
      // console.log('linkClickedFunc kördes');
      return this.linkClicked;
    }
  },
  mounted: function () {
    // justering av höjden för scrollbar plugin
    const pageSubpage = document.getElementsByClassName('page-rsvp')[0];
    const pageSubpageHeight = document.getElementsByClassName('page-rsvp')[0].offsetHeight + 15;
    // console.log(pageSubpageHeight);
    pageSubpage.style.height = pageSubpageHeight + 'px';
  }
};
</script>